import { useCallback } from 'react';
import { Module, ScopeEnum, SessionStorageGenderProductLineType } from 'src/domain';
import { useUnsavedChangesModule } from 'src/hooks/unsaved-changes';
import { useResetInheritance } from '../inheritance';

export const useDiscardChangesModule = (module?: Module, scope?: ScopeEnum, id?: string | number) => {
    const [_, setUnsavedChanges] = useUnsavedChangesModule<SessionStorageGenderProductLineType<unknown>>(
        module,
        scope,
        id
    );
    const discardInheritanceChanges = useResetInheritance({ module });

    const discardChanges = useCallback(async () => {
        await setUnsavedChanges({});
        await discardInheritanceChanges();
    }, [discardInheritanceChanges, setUnsavedChanges]);

    return discardChanges;
};
